import type { Building } from "building-types/building/buildingTypes";
import { hackStartDatumsUntilAllFacesAreRemapped, stackedLevelDatums } from "doc/utils/datumTools";
import { createDatumAbstraction } from "../elements/datums/datumAbstractionFactory";
import memo from "../utils/memo";

function select({ doc }: Building) {
  const { datums } = doc;
  return {
    datums,
  };
}

function generate({ datums }: ReturnType<typeof select>): {
  datumAbstractions: Building["datumAbstractions"];
} {
  /**
   * @TODO - remove hack datumsafter all wall assembly finish layers are mapped to the wall domain
   */
  const allDatums = {
    ...datums,
    ...hackStartDatumsUntilAllFacesAreRemapped,
    ...stackedLevelDatums,
  };

  // generate the abstractions
  const datumAbstractions = Object.values(allDatums).reduce((acc, datum) => {
    acc[datum.id] = createDatumAbstraction(datum);
    return acc;
  }, {});

  return {
    datumAbstractions,
  };
}

export default memo(select, generate);
